import { WidthArchiveLabel } from '@app/shared/components';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import type { DataNode } from 'antd/es/tree';

export const buildDataTree: NClientsList.BuildServicesTree = (
  allParents,
  allChilds = [],
  isFilterByCategories = false
) => {
  const sortedParents = [...allParents].sort((a, b) => {
    const isADeleted = 'IsDeleted' in a ? a.IsDeleted : false;
    const isBDeleted = 'IsDeleted' in b ? b.IsDeleted : false;

    if (isADeleted !== isBDeleted) {
      return isADeleted ? 1 : -1;
    }
    return a?.Name?.localeCompare(b?.Name || '') || 0;
  });

  const result: DataNode[] = sortedParents.map((parent) => {
    const categoryId = parent?.Id;
    const isCategoryDeleted = 'IsDeleted' in parent ? parent.IsDeleted : false;

    const children = !isFilterByCategories
      ? (allChilds || [])
          .filter(({ CategoryId }) => CategoryId === categoryId)
          .sort((a, b) => {
            const isADeleted = a.IsDeleted || false;
            const isBDeleted = b.IsDeleted || false;

            if (isADeleted !== isBDeleted) {
              return isADeleted ? 1 : -1;
            }
            return a?.Name?.localeCompare(b?.Name || '') || 0;
          })
          .map(({ Id: serviceId, Name: serviceName, IsDeleted }) => ({
            key: `child-${serviceId}`,
            title: (
              <WidthArchiveLabel title={serviceName} isDeleted={IsDeleted} />
            ),
            Name: serviceName,
          }))
      : [];

    return {
      key: `parent-${categoryId}`,
      title: (
        <WidthArchiveLabel title={parent?.Name} isDeleted={isCategoryDeleted} />
      ),
      Name: parent?.Name,
      children,
    };
  });

  return result;
};
